import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useFeatureUpdate } from '../hooks/useFeatureUpdate';
import { BaseFeatureProps, Feature } from '../types';
import { renderFeatureName } from './renderFeatureName';
import { DurationEditModal } from './EditFeatureModal';

const DurationFeature = ({ feature, isEditable, onChangeLogRefresh }: BaseFeatureProps) => {
    const [openModal, setOpenModal] = useState(false);
    const { updateFeature, loading } = useFeatureUpdate();

    const handleSave = async (newConfig: Feature['configuration'], reason: string) => {
        await updateFeature(
            feature._id,
            newConfig,
            {
                onSuccess: () => {
                    onChangeLogRefresh();
                },
            },
            reason,
        );
    };

    const displayValue = `${feature.configuration.duration ?? 0} ${feature.configuration.unit ?? ''}`;

    return (
        <>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                alignItems={{ xs: 'stretch', sm: 'center' }}
                justifyContent="space-between"
                spacing={2}
                sx={{ border: (theme) => `1px solid ${theme.palette.border.main}`, borderRadius: 3, p: 2 }}>
                <Box>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                        {renderFeatureName(feature.name || feature.key)}
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {displayValue}
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    onClick={() => setOpenModal(true)}
                    disabled={!isEditable || loading}
                    startIcon={loading ? <CircularProgress size={20} /> : undefined}
                >
                    Modifier
                </Button>
            </Stack>

            <DurationEditModal
                open={openModal}
                feature={feature}
                onClose={() => setOpenModal(false)}
                onSave={handleSave}
                loading={loading}
            />
        </>
    );
};

export default DurationFeature;

